export default __webpack_public_path__ + "static/review3-569b974032f4da0166d577663327b002.png";